import { assertDataMap, identity } from './utils';
import { withContext } from './withContext';
export function withIdentities(identities) {
    if (!assertDataMap(identities, 'identities')) {
        return identity;
    }
    return withContext({ Identities: identities });
}
//# sourceMappingURL=withIdentities.js.map